import {
  CreateCheckoutSessionPayload,
  CreateCheckoutSessionResponse,
} from "@/types/stripe.types";
import { captureError } from "@/utils/common.helpers";
import { API_ROUTES } from "../apiRoutes";
import { REQUEST_METHODS } from "../configs.apiClient";
import { HttpClient } from "../HttpClient";

type RequestBody = Record<string, string | number | boolean | object>;

export class StripeAPIClient {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async createCheckoutSession(
    payload: CreateCheckoutSessionPayload,
    lang?: string,
    dialect?: string,
  ) {
    try {
      const response =
        await this.httpClient.nestRequest<CreateCheckoutSessionResponse>({
          endpoint: API_ROUTES.stripe.createCheckoutSession,
          options: { method: REQUEST_METHODS.POST },
          body: payload as unknown as RequestBody,
          lang,
          dialect,
        });

      return response;
    } catch (error) {
      console.error("Error in StripeAPIClient createCheckoutSession", error);
      throw captureError(error);
    }
  }
}
